import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"
import { useContentfulEntry } from "#/lib/contentful/hooks/useContentfulEntry"
import { StaticAssetID } from "#/lib/contentful/contentfulClient"
import { useQuery, UseQueryResult } from "@tanstack/react-query"
// TypeCalendlyLink is the TimeTap link type, auto-generated from Contentful
import { TypeCalendlyLink } from "#/types/contentful"

/*
 * If the parentCompany is "Solution Consulting (SC) / Sales Demo Accounts" (parentCompanyId = 663) for sales demo,
 * replace all TimeTapLinks with a fake TimeTapLink with abundant availability.
 * See https://carrotfertility.atlassian.net/browse/OP-2576.
 */

const RESOLVED_TIMETAP_LINK_QUERY_KEY = "resolvedTimeTapLink"

export const useResolvedTimeTapLink = (
  timeTapLink: TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>
): UseQueryResult<TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>> => {
  const memberCompany = useGetMemberCompany()
  const salesDemoTimeTapLink = useContentfulEntry(StaticAssetID.TALK_TO_CARROT_SALES_DEMO_TIMETAP_LINK)

  return useQuery<TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>, unknown>(
    [
      RESOLVED_TIMETAP_LINK_QUERY_KEY,
      timeTapLink?.sys?.id,
      memberCompany.data?.parentCompanyId,
      salesDemoTimeTapLink.data?.sys.id
    ],
    () =>
      memberCompany.data?.parentCompanyId === 663
        ? (salesDemoTimeTapLink.data as TypeCalendlyLink<"WITHOUT_UNRESOLVABLE_LINKS", string>)
        : timeTapLink,
    {
      enabled: !!memberCompany.data && !!salesDemoTimeTapLink.data && !!timeTapLink
    }
  )
}
